/* eslint-disable max-len */
import React, { Fragment } from 'react'
import TableBody from './TableBody'
import { useOnClickOutside } from '../../../../../../../CommonMethods/OutsideClick';
import { useState,useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSelector ,useDispatch} from 'react-redux';

const Table=({pageNumber,List,handleSearchParams,sortValue,setisSortSelected,setConfirmationState,setTextAreaMsg})=>{
    const [searchParams,setSearchParams]=useSearchParams()
    const [selectedIndex, setSelectedIndex] = useState(null); 
    const selectedRef = useRef();
    const urlParams = new URLSearchParams(window.location.search);
    const branchUrl = urlParams.get('sort');
    const dispatch=useDispatch()
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });

    const handleAllRowsSelect=(event)=>{
        const paramstoPass=[event.target.checked,pageNumber.toString(),List.data]
        dispatch(selectAllRows(paramstoPass))
        
    }

    const handleSort = (key) => {
        setisSortSelected(true)
        if(sortValue === '') handleSearchParams('sort', `${key}+asc`)
        else {
            if(sortValue.includes(key)) handleSearchParams('sort', `${key}+${sortValue.includes('+desc') ? 'asc' : 'desc'}`)
            else handleSearchParams('sort', `${key}+asc`)
        }
    }


    return(
        <div>
            <div className='h-[calc(100vh-314px)] overflow-auto scrollbar_purple pb-2.5'>
                <table aria-label="Outside Table" className="w-full table-auto">
                    <thead>
                        <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm sticky top-0 left-0 z-[1]">
                            <th id="id" className="px-[18px] py-2 min-w-[210px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Alert Timestamp
                                </span>
                            </th>
                            <th id="username" className="px-[18px] py-2 min-w-[150px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Patient ID
                                </span>
                            </th>
                            <th id="first" className="px-[18px] py-2 min-w-[180px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Patient Name
                                </span>
                            </th>
                            <th id="last" className="px-[18px] py-2 min-w-[80px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Age
                                </span>
                            </th>
                            <th id="status" className="px-[18px] py-2 min-w-[120px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Device ID
                                </span>
                            </th>
                            <th id="status" className="px-[18px] py-2 min-w-[230px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Alert Type
                                </span>
                            </th>
                            <th id="status" className="px-[18px] py-2 min-w-[200px]" onClick={() => {handleSort('reading_details')}}>
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Reading Details
                                    <button  className="pl-2.5 sortedIcon"><img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "reading_details" ?`/images/column-sorting_desc.svg`:'/images/column-sorting.svg'} alt="icon" /></button>
                                </span>
                            </th>
                            <th id="status" className="px-[18px] py-2 min-w-[160px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Reading Type
                                </span>
                            </th>
                            <th id="status" className="px-[18px] py-2 min-w-[150px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Reading Value
                                </span>
                            </th>
                            <th id="status" className="px-[18px] py-2 min-w-[100px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Unit
                                </span>
                            </th>
                            <th id="status" className="px-[18px] py-2 min-w-[200px] text-start">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">User Acknowledged Timestamp
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[180px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">User ID
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[180px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">User Name
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[180px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Organization ID
                                </span>
                            </th>
                            <th id="create_date"className="px-[18px] py-2 min-w-[200px] rounded-tr-sm rounded-br-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Organization Name
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {List?.data?.map((item,index)=>(
                            <Fragment key={item._id}>
                                <TableBody
                                    tableData={item}
                                    List={List}
                                    indexNum={index}
                                    pageNumber={pageNumber}
                                    selectedIndex={selectedIndex}
                                    setSelectedIndex={setSelectedIndex}
                                    selectedRef={selectedRef}
                                    lastIndex={List?.data?.length}
                                    setConfirmationState={setConfirmationState}
                                    setTextAreaMsg={setTextAreaMsg}
                                />
                            </Fragment>
                        ))}
                        
        
                    </tbody>
                    
                </table>

            </div>
        </div>
    )
}

export default Table